import React from 'react';
import DateTime from 'react-datetime';
import CalendarContainer from 'react-datetime/src/CalendarContainer';
import assign from 'object-assign';
import onClickOutside from 'react-onclickoutside'

// Wrapper class to make the DateTime react component use a button instead of a text field
// to prevent wrong inputs.
class MyDateTime extends DateTime {

    handleClickOutside = () => {
        // console.log('onClickOutside() method called')
        this.setState({ open: false })
    }

    render() {
        // TODO: Make a function or clean up this code,
        // logic right now is really hard to follow
        var className = 'rdt' + (this.props.className ?
            (Array.isArray(this.props.className) ?
                ' ' + this.props.className.join(' ') : ' ' + this.props.className) : ''),
            children = [];

        if (this.props.input) {
            var finalInputProps = assign({
                type: 'button',
                className: 'form-control',
                onClick: this.openCalendar,
                onFocus: this.openCalendar,
                onChange: this.onInputChange,
                onKeyDown: this.onInputKey,
                value: this.state.inputValue,
            }, this.props.inputProps);
            if (this.props.renderInput) {
                children = [React.createElement('div', { key: 'i' }, this.props.renderInput(finalInputProps, this.openCalendar, this.closeCalendar))];
            } else {
                children = [React.createElement('button', assign({ key: 'i' }, finalInputProps), this.state.inputValue)];
            }
        } else {
            className += ' rdtStatic';
        }

        if (this.state.open)
            className += ' rdtOpen';

        return React.createElement('div', { className: className }, children.concat(
            React.createElement('div',
                { key: 'dt', className: 'rdtPicker' },
                React.createElement(CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps() })
            )
        ));
    }
}

export default onClickOutside(MyDateTime);


// WEBPACK FOOTER //
// ./src/contact-form/MyDateTime.js